import { OrderStatus } from "@/types/order/order.common";
import { ORDER_CANCEL_STATUSES } from "@/utils/orderCancel";
/**
 * Получить цвет для статуса заказа
 */
export const getOrderStatusColor = (status) => {
    switch (status) {
        case OrderStatus.AWAITING_PAYMENT:
            return "magenta";
        case OrderStatus.NEW:
            return "blue";
        case OrderStatus.CONFIRMED:
            return "cyan";
        case OrderStatus.ASSIGNED:
            return "orange";
        case OrderStatus.EN_ROUTE:
            return "geekblue";
        case OrderStatus.ARRIVED:
            return "purple";
        case OrderStatus.IN_PROGRESS:
            return "processing";
        case OrderStatus.CHARGING:
            return "gold";
        case OrderStatus.COMPLETED:
            return "success";
        case OrderStatus.CANCELLED:
            return "default";
        case OrderStatus.DISPATCHER_CANCELLED:
            return "warning";
        case OrderStatus.FAILED:
            return "error";
        case OrderStatus.FAILED_PAYMENT:
            return "error";
        default:
            return "default";
    }
};
/**
 * Получить порядковый номер статуса для прогресса
 */
export const getOrderStatusStep = (status) => {
    const statusOrder = Array.from(Object.values(OrderStatus));
    return statusOrder.indexOf(status);
};
export const getOrderStatusesList = () => {
    return Array.from(Object.values(OrderStatus));
};
/**
 * Вычислить прогресс выполнения заказа в процентах
 */
export const calculateOrderProgress = (status) => {
    const step = getOrderStatusStep(status);
    const totalSteps = 9; // Количество основных статусов
    if (step === -1) {
        // Для статусов CANCELLED и FAILED
        if (status === OrderStatus.CANCELLED ||
            status === OrderStatus.DISPATCHER_CANCELLED ||
            status === OrderStatus.FAILED ||
            status === OrderStatus.FAILED_PAYMENT) {
            return 0;
        }
        return 0;
    }
    return Math.round((step / (totalSteps - 1)) * 100);
};
/** FR-007: статусы оплаты картой — у корп-заказа их не бывает (CP009, INV-6). */
const CARD_PAYMENT_STATUSES = new Set([
    OrderStatus.AWAITING_PAYMENT,
    OrderStatus.FAILED_PAYMENT,
]);
/**
 * Получить доступные статусы для перехода.
 * FR-007 (UC-105): у корп-заказа (`isCorporate`) из списка убираются `AWAITING_PAYMENT` и `FAILED_PAYMENT` —
 * БД их отклоняет (`CP009`). По умолчанию `false`: частные заказы и прежние вызовы не меняются.
 * WP-DSP-FIX-03: статусов отмены в списке нет — отмена только кнопкой «Отменить» с причиной и инициатором.
 */
export const getAvailableOrderStatuses = (currentStatus, isCorporate = false) => {
    const statuses = getStatusTransitions(currentStatus).filter((status) => !ORDER_CANCEL_STATUSES.has(status));
    return isCorporate ? statuses.filter((status) => !CARD_PAYMENT_STATUSES.has(status)) : statuses;
};
const getStatusTransitions = (currentStatus) => {
    switch (currentStatus) {
        case OrderStatus.AWAITING_PAYMENT:
            return [OrderStatus.NEW, OrderStatus.CANCELLED];
        case OrderStatus.NEW:
            return [OrderStatus.CONFIRMED, OrderStatus.CANCELLED];
        case OrderStatus.CONFIRMED:
            return [OrderStatus.ASSIGNED, OrderStatus.CANCELLED];
        case OrderStatus.ASSIGNED:
            return [OrderStatus.EN_ROUTE, OrderStatus.CANCELLED];
        case OrderStatus.EN_ROUTE:
            return [
                OrderStatus.ARRIVED,
                OrderStatus.FAILED,
                OrderStatus.CANCELLED,
                OrderStatus.FAILED_PAYMENT,
            ];
        case OrderStatus.ARRIVED:
            return [
                OrderStatus.IN_PROGRESS,
                OrderStatus.FAILED,
                OrderStatus.FAILED_PAYMENT,
                OrderStatus.CANCELLED,
            ];
        case OrderStatus.IN_PROGRESS:
            return [
                OrderStatus.CHARGING,
                OrderStatus.FAILED,
                OrderStatus.CANCELLED,
                OrderStatus.FAILED_PAYMENT,
            ];
        case OrderStatus.CHARGING:
            return [OrderStatus.COMPLETED, OrderStatus.FAILED];
        case OrderStatus.COMPLETED:
            return []; // Завершенный заказ нельзя изменить
        case OrderStatus.CANCELLED:
            return [OrderStatus.NEW]; // Можно вернуть в работу
        case OrderStatus.DISPATCHER_CANCELLED:
            return [OrderStatus.NEW]; // WP-DSP-FIX-03 (F2): симметрично CANCELLED
        case OrderStatus.FAILED:
            return [
                OrderStatus.IN_PROGRESS,
                OrderStatus.CANCELLED,
                OrderStatus.FAILED_PAYMENT,
            ];
        default:
            return [];
    }
}; // Константы для статусов с локализацией
export const ORDER_STATUS_LABELS = {
    [OrderStatus.NEW]: "Новый",
    [OrderStatus.CONFIRMED]: "Подтвержден",
    [OrderStatus.AWAITING_PAYMENT]: "Ожидает оплаты",
    [OrderStatus.ASSIGNED]: "Назначен",
    [OrderStatus.EN_ROUTE]: "В пути",
    [OrderStatus.ARRIVED]: "Прибыл",
    [OrderStatus.IN_PROGRESS]: "В процессе",
    [OrderStatus.CHARGING]: "Зарядка",
    [OrderStatus.COMPLETED]: "Завершен",
    [OrderStatus.CANCELLED]: "Отменен",
    [OrderStatus.DISPATCHER_CANCELLED]: "Отменен диспетчером",
    [OrderStatus.FAILED]: "Неудачно",
    [OrderStatus.FAILED_PAYMENT]: "Оплата не прошла",
};
export const getOrderStatusLabel = (orderStatus) => {
    return ORDER_STATUS_LABELS[orderStatus];
};
